<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">This Kind of War</h1>
<h2 class="subtitle">The Classic Military History of the Korean War</h2>
<p class="author">T. R. Fehrenbach</p>
<p class="colophon"><img alt="Open Road logo" src="images/logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section1.vue?a36f2d10